
/**
 * Get the current EST time key in the format 'weekday|hour'
 * where weekday is 1 (Monday) to 7 (Sunday), hour is 0-23
 */
export function getCurrentEstTimeKey(): string {
  const nowUtc = new Date();

  // Convert UTC to EST/EDT offset manually
  // EST is UTC-5, EDT is UTC-4 (Daylight Saving Time)
  const jan = new Date(nowUtc.getFullYear(), 0, 1);
  const jul = new Date(nowUtc.getFullYear(), 6, 1);
  const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  const isDst = nowUtc.getTimezoneOffset() < stdTimezoneOffset;
  const offsetHours = isDst ? -4 : -5;

  const estDate = new Date(nowUtc.getTime() + offsetHours * 60 * 60 * 1000);

  // Subtract 3 hours as per formula NOW()-3/24
  estDate.setHours(estDate.getHours() - 3);

  let weekday = estDate.getUTCDay(); // 0 (Sunday) to 6 (Saturday)
  if (weekday === 0) weekday = 7; // Convert Sunday from 0 to 7
  const hour = estDate.getUTCHours();

  return `${weekday}|${hour}`;
}

/**
 * Convert a Firestore key like '1_08' to 'Monday 8 AM'
 */
export function formatDayHourKey(key: string): string {
  const [weekdayStr, hourStr] = key.split('_');
  const weekdayNum = parseInt(weekdayStr, 10);
  const hourNum = parseInt(hourStr, 10);

  const weekdays = [
    '', // dummy to make 1-based index
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const dayName = weekdays[weekdayNum] || 'Unknown';

  let hourFormatted = '';
  if (hourNum === 0) {
    hourFormatted = '12 AM';
  } else if (hourNum < 12) {
    hourFormatted = `${hourNum} AM`;
  } else if (hourNum === 12) {
    hourFormatted = '12 PM';
  } else {
    hourFormatted = `${hourNum - 12} PM`;
  }

  return `${dayName} ${hourFormatted}`;
}